import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Config from './Config';
import Common from './Common';

import './libs/daijima/trace.js';
import './libs/daijima/requestanimationframe.js';

import '../scss/common.scss';
import '../scss/top.scss';

//CSS Modulesとして使用する場合
// import * as styles from "../scss/common.scss";

Config.getInstance();
new Common();
